<template>
  <div id="sellerProductManagementPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-bag-shopping fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">افزودن محصول</span>
                </div>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="defineProductsTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showDefineProductsTab">تعریف محصول</span>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="listProductsTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showListProductsTab">لیست محصول</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="defineProductsTab" class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row">
              <div class="col-12 font-weight-bold">
                <i class="fa-solid fa-period mr-3"></i> عکس یا فیلم محصول خود را وارد کنید *
                <div
                    dir="ltr">
                  <carousel
                      :autoplay="false"
                      :autoplayTimeout="6000"
                      :dots="false"
                      :loop="false"
                      :margin="5"
                      :nav="false"
                      :responsive="{0:{items:4,margin:1},460:{items:5,margin:1},630:{items:7,margin:1},768:{items:3,margin:1},960:{items:4,margin:1},1200:{items:5,margin:1}}"
                      class="py-1 text-center">
                    <div v-for="i in 10" :key="i" class="row">
                      <div class="col-12">
                        <input v-show="false" :id="i"
                               :accept="i===1?'.jpg,.jpeg.,.gif,.png':'.jpg,.jpeg.,.gif,.png,.mov,.mp4'" type="file"
                               @change="attachmentSelected($event,i)"/>
                        <div :id="'image'+i"
                             class="bg-white rounded-lg d-flex justify-content-center  post-preview-image align-items-center text-center">
                          <i v-if="!hasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                             @click="openUploadFile(i)"></i>
                          <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeFile(i)"></i>
                        </div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
              <div class="col-12">
                <div class="mr-2 mb-2 font-weight-bold">نام محصول</div>
                <v-text-field v-model="defineProductName" :rules="MandatoryFieldRule" dense flat
                              solo>
                </v-text-field>
              </div>
              <div class="col-12">
                <div class="mr-2 mb-2 font-weight-bold">واحد محصول</div>
                <v-autocomplete v-model="defineUnitId" :items="unitsItems" dense
                                flat
                                item-text="Text"
                                item-value="Value"
                                solo>
                </v-autocomplete>
              </div>
              <div class="col-12">
                <div class="mr-2 mb-2 font-weight-bold"> دسته بندی و فیلتر ها</div>

                <div v-for="(item,index) in selectedCategories" :key="index" class="row ">
                  <div class="col-12">
                    <v-autocomplete
                        v-model="categoriesVModels[index]"
                        :data-id="item"
                        :items="childCategories[index]"
                        class="edit-profile-input"
                        color="white"
                        dense
                        flat
                        item-text="Text"
                        item-value="Value"
                        solo
                        @change="loadChildCategories(categoriesVModels[index],index)"></v-autocomplete>
                  </div>
                  <div v-if="childDetailCategories[index] !== undefined && childDetailCategories[index].length > 0  "
                       class="col-12">
                    <div class="border ">
                      <div class="row mx-1 border-bottom">
                        <div class="col-5 text-center border-left">نام</div>
                        <div class="col-7 text-center ">مقدار</div>
                      </div>
                      <div>
                        <div v-for="(child,i) in childDetailCategories[index]" :key="i" class="row mx-1 ">
                          <div class="col-5 ">
                            {{ child.Name }}
                          </div>
                          <div class="col-7 px-0">
                            <v-text-field
                                v-if="child.TypeProductCategoryDetail === 3"
                                v-model="filterId[child.ProductCategoryDetailID]"
                                class="edit-profile-input"
                                color="white"
                                dense
                                flat
                                hide-details
                                solo></v-text-field>
                            <v-autocomplete
                                v-if="child.TypeProductCategoryDetail === 1"
                                v-model="filterId[child.ProductCategoryDetailID]"
                                :items="booleanDetail"
                                class="edit-profile-input"
                                color="white"
                                dense
                                flat
                                hide-details
                                item-text="text"
                                item-value="id"
                                solo></v-autocomplete>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mr-2 mb-2 font-weight-bold">اولین تعداد روز تحویل کالا بعد از ثبت سفارش (مثلا 10روز)</div>
                <v-text-field v-model="defineSendDays" dense flat
                              solo
                              type="number">
                </v-text-field>
              </div>
              <div class="col-6 pl-1 pb-1">
                <div class="mr-2 mb-2 font-weight-bold">وزن هر واحد از محصول Kg</div>
                <v-text-field v-model="weightCalc" dense flat
                              solo
                              type="number">
                </v-text-field>
              </div>
              <div class="col-6 pr-1 pb-1">
                <div class="mr-2 mb-2 font-weight-bold">ارتفاع هر واحد از محصول m</div>
                <v-text-field v-model="heightCalc" dense flat
                              solo
                              type="number">
                </v-text-field>
              </div>
              <div class="col-6 pl-1 pb-1">
                <div class="mr-2 mb-2 font-weight-bold">عرض هر واحد از محصول Kg</div>
                <v-text-field v-model="lengthCalc" dense flat
                              solo  type="number">
                </v-text-field>
              </div>
              <div class="col-6 pr-1 pb-1">
                <div class="mr-2 mb-2 font-weight-bold">طول هر واحد از محصول m</div>
                <v-text-field v-model="widthCalc" dense flat
                              solo  type="number">
                </v-text-field>
              </div>
              <div class="col-12 py-1 mb-6">
                <div class="mr-2 mb-2 font-weight-bold">توضیحات محصول</div>
                <editor-content :editor="productDescriptionEditor" class="text-editor"/>
              </div>
              <div class="col-12 py-1 mb-6">
                <div class="mr-2 mb-2 font-weight-bold">نقد و بررسی</div>
                <editor-content :editor="editorEdit" class="text-editor"/>
              </div>
<!--              <div class="col-12 py-1 mb-6">
                <div class="mr-2 mb-2 font-weight-bold">نحوه ارسال بار این محصول</div>
                <editor-content :editor="editorSendWay" class="text-editor"/>
              </div>-->
              <div class="col-12">
                <div class="row primary-bg mx-1 rounded-lg" @click="addProductTypes">
                  <div class="col-auto">
                    <i class="fas fa-circle-plus fa-xl pointer white--text"></i>
                  </div>
                  <div class="col text-center white--text">
                    تعریف تیپ های محصول
                  </div>
                </div>
                <div class="red--text mt-2 pr-2">*ورود حداقل یک تیپ از محصول الزامی است.</div>
              </div>
              <div class="col-12">
                <div v-for="(item,index) in productTypes" :key="index" class="bg-white rounded-lg p-2 my-2 ">
                  <div class="p-2 font-weight-bold">
                   <span class="d-inline-block w-75">
                      تیپ {{ index + 1 }} از محصول
                   </span>
                    <span class="d-inline-block w-25 text-left">
                      <v-btn icon @click="removeList(index)">
                        <i class="fas fa-circle-minus fa-xl pointer "></i>
                      </v-btn>
                    </span>
                  </div>

                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">رنگ محصول</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.productColor" dense flat
                                  outlined></v-text-field>
                  </span>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">کد رنگ hex</span>
                    <span class="d-inline-block w-75">
                       <v-text-field v-model="item.color" class="edit-profile-input ma-0 pa-0" dense flat outlined>
                  <template v-slot:append>
                    <v-menu v-model="item.menu" :close-on-content-click="false" bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on" :style="'background-color:' + item.color" class="color-picker"/>
                      </template>
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker v-model="item.color"
                                          flat hide-inputs/>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
                  </span>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">سایز محصول</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.productSize" dense flat
                                  outlined></v-text-field>
                  </span>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">درجه کیفی</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.quality" dense flat
                                  outlined  type="number"></v-text-field>
                  </span>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">نوع محصول</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.type" dense flat
                                  outlined></v-text-field>
                  </span>
                  </div>
                  <div class="mb-2">
                    <span class="d-inline-block w-25 font-weight-bold">قیمت محصول</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.productPrice" dense flat hide-details
                                  outlined  type="number"></v-text-field>

                  </span>
                    <div class="font12px text-center mt-1 font-weight-bold">درج عدد صفر با عنوان *برای اطلاع از قیمت
                      تماس بگیرید* نمایش داده می شود
                    </div>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">درصد تخفیف</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.productDiscount" dense flat
                                  outlined  type="number"> </v-text-field>
                  </span>
                  </div>
                  <div>
                    <span class="d-inline-block w-25 font-weight-bold">موجودی</span>
                    <span class="d-inline-block w-75">
                    <v-text-field v-model="item.numHave" dense flat
                                  outlined  type="number"></v-text-field>
                  </span>
                  </div>
                  <div class="col-12 pt-0 font-weight-bold">
                    <i class="fa-solid fa-period mr-3 "></i> عکس تیپ محصول را وارد کنید
                    <input v-show="false" :id="'typeImageInput'+item.id" accept=".jpg,.jpeg.,.gif,.png" type="file"
                           @change="productTypePhoto($event,item.id)"/>
                    <div :id="'typeImage'+item.id"
                         :style=" 'background-image:url('+item.selectedImageFilePath+')'"
                         class="bg-white rounded-lg d-flex justify-content-center mr-auto ml-1  post-preview-image align-items-center text-center border">
                      <i v-if="!item.hasPhoto" class="fas fa-circle-plus fa-xl pointer"
                         @click="openUploadFileForTypes(item.id)"></i>
                      <i v-else class="fas fa-circle-xmark white--text fa-xl pointer"
                         @click="removeProductTypePhoto(item.id)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <v-btn block color="primary" @click="defineProduct">
                  ثبت
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div v-if="listProductsTab" class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div v-if="productsList.length <= 0" class="  text-center">
              <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
              <div class="mt-2">
                هنوز محصولی تعریف نشده است
              </div>

            </div>
            <div v-else class="row">
              <div class="col pt-0 ">
                <v-text-field
                    v-model="searchKeyWord"
                    append-icon="far fa-magnifying-glass"
                    class="rounded-lg"
                    clearable
                    dense
                    flat
                    hide-details
                    placeholder="...Search Product"
                    solo
                    @keyup="search"
                    @click:clear="removeSearchHistory">
                </v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-for="(item,i) in productsList" :key="i" class=" pb-2">
                  <div class="row bg-white">
                    <div class="col-4">
                      <v-img :src="$replaceHttps(item.FileUrl)" class="rounded-lg" height="100" width="100">

                      </v-img>
                    </div>
                    <div class="col-8 pr-0">
                      <div class="font-weight-bold ">{{ item.Name }}</div>
                      <div>{{ item.ProductCategoryName }}</div>
                      <div>واحد: {{ item.ProductUnitName }}</div>
                      <div>تاریخ درج: {{ $convertDate(item.InsertDate) }}</div>
                      <div>وضعیت: {{ $TypeVendorProductStatus(item.TypeVendorProductStatus) }}</div>
                    </div>
                    <div class="col-12 pt-0">
                      <div class="row mx-1">
                        <div v-for="(type,i) in item.VendorProductTipViewModels" :key="i" class="col-6 p-1">
                          <div class="primary-bg rounded-lg white--text p-2 py-3">
                            <div class="text-center">تیپ {{ i + 1 }}</div>
                            <div class="mt-1">
                              <span class="d-inline-block w-50 ">رنگ</span>
                              <span class="d-inline-block w-50 text-center">{{ type.Color }}
                                <span class="text-color float-left"><span :style="'background-color:'+type.ColorHex"
                                                                          class="hex-color-circle-tip rounded-circle"></span></span></span>
                            </div>
                            <div class="mt-2">
                              <span class="d-inline-block w-50">سایز</span>
                              <span class="d-inline-block w-50 text-center">{{ type.Size }}</span>
                            </div>
                            <div class="mt-2">
                              <span class="d-inline-block w-50">درجه کیفی</span>
                              <span class="d-inline-block w-50 text-center">{{ type.Quality }}</span>
                            </div>
                            <div class="mt-2">
                              <span class="d-inline-block w-50">کد محصول</span>
                              <span class="d-inline-block w-50 text-center">{{ item.Code }}</span>
                            </div>
                            <div class="mt-2">
                              <span class="d-inline-block w-50">قیمت محصول</span>
                              <span class="d-inline-block w-50 text-center">{{ $numberWithCommas(type.Price) }}</span>
                            </div>
                            <div class="mt-2">
                              <span class="d-inline-block w-50">درصد تخفیف</span>
                              <span class="d-inline-block w-50 text-center">{{ type.Discount }}</span>
                            </div>
                            <div class="mt-4 text-left ">
                              <v-img :src="$replaceHttps(type.FileUrl)" class="rounded-lg mr-auto" height="70"
                                     width="70">

                              </v-img>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mr-1 pb-1 font-weight-bold d-flex align-items-center justify-space-between">
                      <div><i class="fa-solid fa-shuffle ml-1 fa-lg"></i>
                        تغییر وضعیت نمایش محصول در پروفایل
                      </div>
                      <div class="ml-3 ">
                        <v-btn v-if="item.IsActive" class="px-1" color="primary" depressed small
                               @click="changeActive(item.VendorProductID)">
                          <span class="font12px"> تغییر به عدم نمایش</span>
                        </v-btn>
                        <v-btn v-else class="px-1" color="primary" depressed outlined small
                               @click="changeActive(item.VendorProductID)">
                          <span class="font12px"> تغییر به نمایش</span>
                        </v-btn>
                      </div>
                    </div>
                    <div class="col-12 mr-1 py-1 font-weight-bold pointer"
                         @click="showProductDetail(item.VendorProductTipViewModels)">
                      <i class="far fa-file-lines ml-1 fa-lg"></i>
                      مشاهده ریز مشخصات
                    </div>
                    <div class="col-12 mr-1 py-1 font-weight-bold pointer"
                         @click="openReportModal(item.CountSell,item.CountVisit)">
                      <i class="far fa-file-magnifying-glass ml-1 fa-lg"></i>
                      آمار محصول
                    </div>
                    <div class="col-12 mr-1 py-1 font-weight-bold pointer"
                         @click="getGalleryItems(item.VendorProductID)">
                      <i class="far fa-image-landscape ml-1 fa-lg"></i>
                      مشاهده عکس
                    </div>
                    <div class="col-12 mr-1 py-1 font-weight-bold pointer" @click="editProduct(item.VendorProductID)">
                      <i class="far fa-pen-to-square ml-1 fa-lg"></i>
                      ویرایش

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-bottom-sheet v-model="openBottomSheetProductDetail" class="bottom-sheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            ریز مشخصات محصول
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheetProductDetail = !openBottomSheetProductDetail">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>

        <v-data-table
            :headers="productDetailHeaders"
            :items="productDetail"
            :items-per-page="5"
            :light="true"
            :mobile-breakpoint="680"
            class="data-table">
          <template v-slot:[`item.FileUrl`]="{ item }">
            <div>
              <v-img :src="$replaceHttps(item.FileUrl)" height="150"
                     width="150">
              </v-img>
            </div>
          </template>
          <template v-slot:[`item.Price`]="{ item }">
            <div>
              {{ $numberWithCommas(item.Price) }}

            </div>
          </template>
          <template v-slot:[`item.ColorHex`]="{ item }">
            <div :style="'background-color:'+item.ColorHex" class="p-5">
              {{ item.Color }}
            </div>
          </template>
        </v-data-table>


      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openBottomSheet" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            آمار
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheet = !openBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12">
            <div>تعداد بازدید :{{ reportVisit }}</div>
            <div>تعداد فروش :{{ reportSell }}</div>

          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openGalleryBottomSheet" class="bottom-sheet">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="closeGalleryBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div v-if="isSelectedGalleryItem" class="col-12 text-center">
            <img v-if="typeGalleryIsPicture" :src="$replaceHttps(srcSelectedGallery)" alt="" class="img-fluid">
            <video v-else :src="$replaceHttps(srcSelectedGallery)" controls height="400"></video>

          </div>
          <div v-if="openGalleryBottomSheet" class="col-12">
            <div
                dir="ltr">
              <carousel
                  :autoplay="false"
                  :autoplayTimeout="6000"
                  :dots="false"
                  :loop="false"
                  :margin="1"
                  :nav="false"
                  :temes="1"
                  class="py-1 text-center">
                <div v-for="(item,i) in galleryItems" :key="i" style="height: 110px;">
                  <v-img v-if="item.TypeStrucGallery === 1" :src="$replaceHttps(item.FileUrl)" contain
                         height="110" @click="showSelectedGalleryItem(item.TypeStrucGallery,item.FileUrl)"></v-img>
                  <video v-else :src="$replaceHttps(item.FileUrl)" style="width: 100%" @click="showSelectedGalleryItem(item.TypeStrucGallery,item.FileUrl)"
                         @loadeddata="videoLoaded"></video>
                </div>
              </carousel>
            </div>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-dialog
        v-model="editDialog"
        fullscreen
        hide-overlay
        scrollable
        transition="dialog-bottom-transition">
      <v-card class="p-3 dialog-background-color text-right ">
        <v-toolbar
            color="primary"
            dark>
          <v-btn
              icon
              @click="editDialog = false">
            <i class="fas fa-circle-xmark white--text fa-2x"></i>
          </v-btn>
          <v-toolbar-title>
            <span>ویرایش</span></v-toolbar-title>
        </v-toolbar>
        <v-divider class="m-0 pt-5"></v-divider>
        <v-card-text v-if="isEditDataLoaded">
          <div class="col-12 font-weight-bold">
            <i class="fa-solid fa-period mr-3"></i> عکس یا فیلم محصول خود را وارد کنید *
            <div
                dir="ltr">

              <carousel
                  v-if="isGalleryLoaded"
                  :autoplay="false"
                  :autoplayTimeout="6000"
                  :dots="false"
                  :loop="false"
                  :margin="5"
                  :nav="false"
                  :responsive="{0:{items:3,margin:1},600:{items:5,margin:1},900:{items:7,margin:1},1200:{items:10,margin:1}}"
                  class="py-1 text-center">
                <div v-for="i in 10" :key="i" class="row">
                  <div class="col-12">
                    <input v-if="editGallery[i-1] !== undefined" v-show="false"
                           :id="i"
                           :accept="i===1?'.jpg,.jpeg.,.gif,.png':'.jpg,.jpeg.,.gif,.png,.mov,.mp4'" type="file"
                           @change="attachmentSelectedEdit($event,i,editGallery[i-1].VendorProductGalleryID)"/>
                    <input v-else v-show="false"
                           :id="i"
                           :accept="i===1?'.jpg,.jpeg.,.gif,.png':'.jpg,.jpeg.,.gif,.png,.mov,.mp4'" type="file"
                           @change="attachmentSelectedEdit($event,i)"/>
                    <div
                        v-if="editGallery[i-1] !== undefined && editGallery[i-1].FileUrl !== null && editGallery[i-1].FileUrl !== undefined && editGallery[i-1].TypeStrucGallery === 1"
                        :id="'imageEdit'+i"
                        :style="'background-image:url('+editGallery[i-1].FileUrl+')'"
                        class="bg-white rounded-lg d-flex justify-content-center border post-preview-image align-items-center text-center">
                      <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                         @click="openUploadFileEdit(i)"></i>
                      <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeFileEdit(i)"></i>
                    </div>
                    <div
                        v-else-if="editGallery[i-1] !== undefined && editGallery[i-1].FileUrl !== null && editGallery[i-1].FileUrl !== undefined && editGallery[i-1].TypeStrucGallery === 2"
                        :id="'imageEdit'+i"
                        class="bg-white rounded-lg position-relative d-flex justify-content-center border post-preview-image align-items-center text-center overflow-hidden">
                      <video style="width: 100%" @loadeddata="videoLoaded">
                        <source :src="editGallery[i-1].FileUrl ">
                      </video>
                      <div class="position-absolute">
                        <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                           @click="openUploadFileEdit(i)"></i>
                        <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeFileEdit(i)"></i>
                      </div>
                    </div>
                    <div v-else :id="'imageEdit'+i"
                         class="bg-white rounded-lg d-flex justify-content-center border post-preview-image align-items-center text-center">
                      <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                         @click="openUploadFileEdit(i)"></i>
                      <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeFileEdit(i)"></i>
                    </div>
                  </div>

                </div>
              </carousel>
            </div>
          </div>
          <div>
            نام محصول
          </div>
          <v-text-field
              v-model="editProductName"
              background-color="secondary"
              dense
              flat
              solo
              type="text">
          </v-text-field>
          <div class="p-0">
            واحد محصول
          </div>
          <v-autocomplete
              v-model="editProductUnitID"
              :items="unitsItems"
              background-color="secondary"
              dense
              flat
              item-text="Text"
              item-value="Value"
              solo></v-autocomplete>
          <div class="p-0">
            دسته بندی و فیلتر ها
          </div>
          <div v-for="(item,index) in editSelectedCategories" :key="index" class="row ">
            <div class="col-12">
              <v-autocomplete
                  v-model="editCategoriesVModels[index]"
                  :data-id="item"
                  :items="editChildCategories[index]"
                  background-color="secondary"
                  dense
                  flat
                  item-text="Text"
                  item-value="Value"
                  solo
                  @change="editLoadChildCategories(editCategoriesVModels[index],index)"></v-autocomplete>
            </div>
            <div v-if="editChildDetailCategories[index] !== undefined && editChildDetailCategories[index].length > 0  "
                 class="col-12">
              <div class="border ">
                <div class="row mx-1">
                  <div class="col-5   text-center border-left">نام</div>
                  <div class="col-7   text-center ">مقدار</div>
                </div>
                <div>
                  <div v-for="(child,i) in editChildDetailCategories[index]" :key="i" class="row mx-1 ">
                    <div class="col-5 ">
                      {{ child.Name }}
                    </div>
                    <div class="col-7 px-0">
                      <v-text-field
                          v-if="child.TypeProductCategoryDetail === 3"
                          v-model="editFilterId[child.ProductCategoryDetailID]"
                          background-color="secondary"
                          dense
                          flat
                          hide-details
                          solo></v-text-field>
                      <v-autocomplete
                          v-if="child.TypeProductCategoryDetail === 1"
                          v-model="editFilterId[child.ProductCategoryDetailID]"
                          :items="booleanDetail"
                          background-color="secondary"
                          dense
                          flat
                          hide-details
                          item-text="text"
                          item-value="id"
                          solo></v-autocomplete>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="p-0">
            اولین تعداد روز تحویل کالا بعد از ثبت سفارش (مثلا 10 روز)
          </div>
          <v-text-field
              v-model="editDSendDays"
              background-color="secondary"
              dense
              flat
              solo
              type="number">
          </v-text-field>
          <div class="p-0">
            وزن بر حسب کیلوگرم - جهت حمل
          </div>
          <v-text-field
              v-model="editWeightCalc"
              background-color="secondary"
              dense
              flat
              solo
              type="number">
          </v-text-field>
          <div class="p-0">
            ارتفاع بر حسب متر - جهت حمل
          </div>
          <v-text-field
              v-model="editHeightCalc"
              background-color="secondary"
              dense
              flat
              solo
              type="number">
          </v-text-field>
          <div class="p-0">
            طول بر حسب متر - جهت حمل
          </div>
          <v-text-field
              v-model="editWidthCalc"
              background-color="secondary"
              dense
              flat
              solo
              type="number">
          </v-text-field>
          <div class="p-0">
            عرض بر حسب متر - جهت حمل
          </div>
          <v-text-field
              v-model="editLengthCalc"
              background-color="secondary"
              dense
              flat
              solo
              type="number">
          </v-text-field>
<!--          <div class="p-0">-->
<!--            نحوه ارسال بار این محصول-->
<!--          </div>-->
<!--          <editor-content :editor="editProductSend" class="text-editor-edit-dialog"/>-->
          <div class="pt-5">
            نقد و بررسی
          </div>
          <editor-content :editor="editProductReview" class="text-editor-edit-dialog"/>
          <div class="pt-5">
            توضیحات
          </div>
          <editor-content :editor="editProductDescription" class="text-editor-edit-dialog"/>

          <div class="row">
            <div class="col-2 pl-0 mt-1">
              <i class="fal fa-plus-circle plus-icon" @click="editAppendProductTip"></i>
            </div>
            <div class="col-10 pr-0">
              <v-btn
                  block
                  color="primary"
                  @click="editAppendProductTip">
                تعریف تیپ های محصول
              </v-btn>
            </div>
          </div>
          <div class="row ">
            <div v-if="editProductTip !== undefined" class="col-12">
              <div v-for="(item,index) in editProductTip" :key="index" class="border p-3 my-2">
                <div v-if="item.IsRemove === 'false'">
                  <div class="p-2 font-weight-bold">
                   <span class="d-inline-block w-75">
                      تیپ {{ index + 1 }} از محصول
                   </span>
                    <span class="d-inline-block w-25 text-left">
                      <v-btn icon @click="editRemoveTip(index)">
                        <i class="fas fa-circle-minus fa-xl pointer "></i>
                      </v-btn>
                    </span>
                  </div>

                  <div>
                    رنگ محصول
                  </div>
                  <v-text-field
                      v-model="item.productColor"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="text">
                  </v-text-field>
                  <div>
                    کد HEX رنگ محصول
                  </div>
                  <v-text-field v-model="item.color" background-color="secondary" class="edit-profile-input ma-0 pa-0"
                                dense
                                flat
                                solo>
                    <template v-slot:append>
                      <v-menu v-model="item.menu" :close-on-content-click="false" bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on" :style="'background-color:' + item.color" class="color-picker"/>
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker v-model="item.color"
                                            flat hide-inputs/>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                  <div>
                    سایز محصول
                  </div>
                  <v-text-field
                      v-model="item.productSize"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="text">
                  </v-text-field>
                  <div>
                    درجه کیفی
                  </div>
                  <v-text-field
                      v-model="item.quality"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="number">
                  </v-text-field>
                  <div>
                    نوع محصول
                  </div>
                  <v-text-field
                      v-model="item.type"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="text">
                  </v-text-field>
                  <div>
                    قیمت محصول به تومان
                    <div class="font3vw">* درج عدد صفر با عنوان "برای اطلاع از قیمت تماس بگیرید " ثبت خواهد شد.</div>
                  </div>
                  <v-text-field
                      v-model="item.productPrice"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="number">
                  </v-text-field>
                  <div>
                    درصد تخفیف
                  </div>
                  <v-text-field
                      v-model="item.productDiscount"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="number">
                  </v-text-field>
                  <div>
                    موجودی
                  </div>
                  <v-text-field
                      v-model="item.numHave"
                      background-color="secondary"
                      dense
                      flat
                      solo
                      type="number">
                  </v-text-field>
                  <div class="row">
                    <div class="col-12 pt-0">
                      <i class="fa-solid fa-period"></i> عکس تیپ محصول را وارد کنید
                      <input v-show="false" :id="'typeImageInputEdit'+item.id" accept=".jpg,.jpeg.,.gif,.png"
                             type="file"
                             @change="productTypePhotoEdit($event,item.id)"/>
                      <div :id="'typeImage'+item.id"
                           :style=" 'background-image:url('+$replaceHttps(item.selectedImageFilePath)+')'"
                           class="bg-white rounded-lg d-flex justify-content-center mr-auto ml-1  post-preview-image align-items-center text-center border">

                        <i v-if="!item.hasEditTipPic" class="fas fa-circle-plus fa-xl pointer"
                           @click="openUploadFileForTypesEdit(item.id)"></i>

                        <v-btn v-else icon @click="removeProductTypePhotoEdit(item.id)">
                          <i class="fas fa-circle-xmark  fa-xl pointer bg-white"
                          ></i>
                        </v-btn>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-btn block color="primary" @click="editDefineProduct">
            ویرایش محصول
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay id='editProductLoader' :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
let _this = null
import BackBar from "@/components/BackBar";
import carousel from "vue-owl-carousel";
import {Editor, EditorContent} from 'tiptap';


export default {
  name: "SellerProductManagement",
  metaInfo: {
    title: 'ایوان خانه- افزودن محصول',
  },
  components: {BackBar, carousel, EditorContent},
  data: () => ({
    selectTypeItems: [{id: 1, name: 'عکس'}, {id: 2, name: 'ویدئو'}],
    editDialog: false,
    openBottomSheetProductDetail: false,
    reportSell: '',
    reportVisit: '',
    openBottomSheet: false,
    showResult: false,
    resultText: '',
    showLoaderDialog: false,
    defineProductsTab: true,
    listProductsTab: false,
    hasPhoto: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false},
    editHasPhoto: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false},
    productDescription: '',
    productDescriptionEditor: null,
    productReviewEditor: null,
    productReview: '',
    productTypes: [{
      numHave: 0,
      productDiscount: 0,
      productPrice: 0,
      quality: '',
      productSize: '',
      hexCode: '',
      productColor: '',
      type: '',
      color: '#000000',
      menu: false,
      hasPhoto: false,
      selectedImageFilePath: '',
      fileName: '',
      id: 0,
      file: null
    }],
    productsList: [],
    productDetail: {},
    productDetailHeaders: [
      {text: 'رنگ محصول', value: 'ColorHex'},
      {text: 'درجه کیفی', value: 'Quality'},
      {text: 'نوع محصول', value: 'Type'},
      {text: 'قیمت محصول (تومان)', value: 'Price'},
      {text: 'تخفیف', value: 'Discount'},
      {text: 'موجودی', value: 'CountAvilable'},
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'محصول', value: 'VendorProductName'},
    ],
    searchKeyWord: '',
    hasResult: true,
    allProductList: [],
    defineProductName: null,
    defineUnitId: null,
    unitsItems: [],
    selectedCategories: [""],
    categoriesVModels: [],
    childCategories: [],
    childDetailCategories: [[]],
    filterId: {},
    booleanDetail: [{id: 'true', text: 'بله'}, {id: 'false', text: 'خیر'}],
    defineSendDays: null,
    widthCalc: null,
    lengthCalc: null,
    heightCalc: null,
    weightCalc: null,
    editorEdit: null,
    defineProductVendorId: '',
    editorSendWay: null,
    dynamicID: 0,
    editProductName: null,
    editProductUnitID: null,
    vendorProductId: null,
    editDSendDays: null,
    editWeightCalc: null,
    editHeightCalc: null,
    editWidthCalc: null,
    editLengthCalc: null,
    editTypeVendorProductStatus: null,
    hasEditMainPic: false,
    editMainPic: null,
    editProductTip: [],
    editProductSend: null,
    editChildCategories: [],
    editSelectedCategories: [],
    editCategoriesVModels: [],
    editChildDetailCategories: [],
    editFilterId: {},
    editIsActive: null,
    editVendorID: null,
    editProductReview: null,
    editProductDescription: null,
    isEditDataLoaded: false,
    selectedFileObjects: {},
    selectedFileType: {},
    selectedFileObjectsEdit: {},
    selectedFileTypeEdit: {},
    selectedGalleryIDEdit: {},
    editGallery: [],
    isGalleryLoaded: false,
    MandatoryFieldRule: [v => !!v || 'فیلد اجباری'],
    isMediaChanged: false,
    openGalleryBottomSheet: false,
    galleryItems: [],
    srcSelectedGallery: null,
    typeGalleryIsPicture: false,
    isSelectedGalleryItem: false,


  }),
  mounted() {
    _this = this
    this.productDescriptionEditor = new Editor({
      content: this.productDescription,
    })
    this.productReviewEditor = new Editor({
      content: this.productReview,
    })
    this.getProductsList()
    this.getDefineProductData()
    // this.loadVideoFrame('https://pwa.eyvankhaneh.app/img/VendorProductGallery/65cb10fb90184014b2002368ec8c5749.mp4')
  },
  methods: {
    showDefineProductsTab() {
      this.defineProductsTab = true;
      this.listProductsTab = false
    },
    showListProductsTab() {
      this.defineProductsTab = false;
      this.listProductsTab = true
    },
    attachmentSelected(e, i) {
      let files = e.target.files;
      if (files.length > 0) {

        this.hasPhoto[i] = true;

        let file = event.target.files[0];
        _this.selectedFileObjects[i] = file
        let fileReader = new FileReader();
        if (file.type.match('image')) {
          fileReader.onload = function () {
            document.getElementById('image' + i).style.backgroundImage = "url(" + fileReader.result + ")"

            _this.selectedFileType[i] = 1
          };

          fileReader.readAsDataURL(file);
        } else {
          try {
            fileReader.onload = function () {
              let blob = new Blob([fileReader.result], {type: file.type});
              let url = URL.createObjectURL(blob);
              let video = document.createElement('video');

              _this.selectedFileType[i] = 2
              let timeupdate = function () {
                if (_this.snapImage(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                  video.pause();
                }
              };
              video.addEventListener('loadeddata', function () {
                if (_this.snapImage(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                }
              });

              video.addEventListener('timeupdate', timeupdate);
              video.preload = 'metadata';
              video.src = url;
              video.muted = true;
              video.playsInline = true;
              video.play();
            };
            fileReader.readAsArrayBuffer(file);
          } catch (e) {
            console.log(e)
          }

        }
      }
    },
    attachmentSelectedEdit(e, i, id) {
      let files = e.target.files;
      if (files.length > 0) {
        this.isMediaChanged = true
        this.editHasPhoto[i] = true;

        let file = event.target.files[0];
        _this.selectedFileObjectsEdit[i] = file
        _this.selectedGalleryIDEdit[i] = id
        let fileReader = new FileReader();
        if (file.type.match('image')) {
          fileReader.onload = function () {
            document.getElementById('imageEdit' + i).style.backgroundImage = "url(" + fileReader.result + ")"

            _this.selectedFileTypeEdit[i] = 1
          };

          fileReader.readAsDataURL(file);
        } else {
          try {
            fileReader.onload = function () {
              let blob = new Blob([fileReader.result], {type: file.type});
              let url = URL.createObjectURL(blob);
              let video = document.createElement('video');

              _this.selectedFileTypeEdit[i] = 2
              let timeupdate = function () {
                if (_this.snapImageEdit(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                  video.pause();
                }
              };
              video.addEventListener('loadeddata', function () {
                if (_this.snapImageEdit(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                }
              });

              video.addEventListener('timeupdate', timeupdate);
              video.preload = 'metadata';
              video.src = url;
              video.muted = true;
              video.playsInline = true;
              video.play();
            };
            fileReader.readAsArrayBuffer(file);
          } catch (e) {
            console.log(e)
          }

        }
      }
    },
    snapImage(url, video, i) {
      let canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      let image = canvas.toDataURL();
      let success = image.length > 100000;
      if (success) {
        document.getElementById('image' + i).style.backgroundImage = "url(" + image + ")"

        // URL.revokeObjectURL(url);
      }
      return success;
    },
    snapImageEdit(url, video, i) {
      let canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      let image = canvas.toDataURL();
      let success = image.length > 100000;
      if (success) {
        document.getElementById('imageEdit' + i).style.backgroundImage = "url(" + image + ")"

        // URL.revokeObjectURL(url);
      }
      return success;
    },
    openUploadFile(i) {
      document.getElementById(i).click()
    },
    openUploadFileEdit(i) {
      document.getElementById(i).click()
    },
    removeFile(i) {
      document.getElementById('image' + i).style.backgroundImage = ""
      delete this.selectedFileObjects[i]
      delete this.selectedFileType[i]
      this.hasPhoto[i] = false;
    },
    removeFileEdit(i) {
      document.getElementById('imageEdit' + i).style.backgroundImage = ""
      delete this.selectedFileObjectsEdit[i]
      delete this.selectedFileTypeEdit[i]
      delete this.selectedGalleryIDEdit[i]
      this.editGallery[i - 1] = undefined
      this.isMediaChanged = true
      this.editHasPhoto[i] = false;
    },
    addProductTypes() {
      this.dynamicID += 1
      this.productTypes.push({
        numHave: 0,
        productDiscount: 0,
        productPrice: 0,
        quality: '',
        productSize: '',
        hexCode: '',
        productColor: '',
        type: '',
        color: '#000000',
        menu: false,
        hasPhoto: false,
        selectedImageFilePath: '',
        fileName: '',
        id: this.dynamicID,
        file: null
      })
    },
    removeList(index) {
      if (this.productTypes.length === 1) {
        this.resultText = 'حداقل یک تیپ باید تعریف کنید'
        this.showResult = true
      } else {
        this.productTypes.splice(index, 1)

      }
    },
    productTypePhoto(e, i) {
      let files = e.target.files;
      if (files.length > 0) {
        this.productTypes[i].hasPhoto = true
        let imageName = files[0].name
        if (imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          // document.getElementById('typeImage' + i).style.backgroundImage = "url(" + fr.result + ")"
          this.productTypes[i].selectedImageFilePath = fr.result
          this.productTypes[i].file = files[0]
          this.selectedImageCoverFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.productTypes[i].hasPhoto = false

      }
    },
    removeProductTypePhoto(i) {
      document.getElementById('typeImage' + i).style.backgroundImage = ""
      this.productTypes[i].selectedImageFilePath = ""
      this.productTypes[i].hasPhoto = false
    },
    openUploadFileForTypes(i) {
      document.getElementById('typeImageInput' + i).click()
    },
    getProductsList() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_ListVendorProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.productsList = json
            this.allProductList = json
          })
          .catch(error => console.log('error', error));

    },
    changeActive(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);
      urlencoded.append("TableName", "VendorProducts");
      urlencoded.append("IDName", "VendorProductID");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/ChangeActive", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.getProductsList()
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    showProductDetail(detail) {
      this.productDetail = detail
      this.openBottomSheetProductDetail = true;
    },
    openReportModal(sell, visit) {
      this.openBottomSheet = true
      this.reportSell = sell;
      this.reportVisit = visit
    },
    removeSearchHistory() {
      this.productsList = this.allProductList
      this.hasResult = true
    },
    search() {
      let result = this.allProductList.filter(x => x.Name.includes(this.searchKeyWord));
      if (this.searchKeyWord === '') {
        this.productsList = this.allProductList
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {
          this.hasResult = true
          this.productsList = result
        }
      }
    },
    getDefineProductData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_DefineVendorProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.defineProductName = json.Name;
            this.defineProductVendorId = json.VendorID;
            this.defineUnitId = json.ProductUnitID;
            this.defineSendDays = json.DayDeliver;
            this.defineSendWay = json.HowSendProduct;
            this.unitsItems = json.ProductUnits;
            this.defineEdit = json.ProductReview;
            this.weightCalc = json.WeightCalc;
            this.heightCalc = json.HeightCalc;
            this.lengthCalc = json.LengthCalc;
            this.widthCalc = json.WidthCalc;
            this.childCategories.push(json.ProductCategories);
            this.editorSendWay = new Editor({
              content: this.defineSendWay,
            })
            this.editorEdit = new Editor({
              content: this.defineEdit,
            })

          })
          .catch(error => console.log('error', error));
    },
    loadChildCategories(id, index) {
      this.childDetailCategories.splice(index - 1, this.childDetailCategories.length - index + 1)
      this.selectedCategories.splice(index + 1, this.selectedCategories.length - index + 1)
      this.childCategories.splice(index + 1, this.childCategories.length - index + 1)
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductCategoryID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadChildDetialCategoriesApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              this.childDetailCategories.push(json)
            }

          })
          .catch(error => console.log('error', error));


      let myHeaders1 = new Headers();
      myHeaders1.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded1 = new URLSearchParams();
      urlencoded1.append("ProductCategoryParentID", id);

      let requestOptions1 = {
        method: 'POST',
        headers: myHeaders1,
        body: urlencoded1,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadChildCategoriesApi", requestOptions1)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              this.childCategories.push(json)
              this.selectedCategories.push(id)
            }

          })
          .catch(error => console.log('error', error));
    },
    defineProduct() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      if (this.selectedFileObjects[1] !== undefined) {
        formdata.append('ImageFileUrl', this.selectedFileObjects[1]);
      }
      if (this.selectedFileObjects[2] !== undefined) {
        formdata.append('ImageFileUrl1', this.selectedFileObjects[2]);
        formdata.append('FileType1', this.selectedFileType[2]);
      }
      if (this.selectedFileObjects[3] !== undefined) {
        formdata.append('ImageFileUrl2', this.selectedFileObjects[3]);
        formdata.append('FileType2', this.selectedFileType[3]);
      }
      if (this.selectedFileObjects[4] !== undefined) {
        formdata.append('ImageFileUrl3', this.selectedFileObjects[4]);
        formdata.append('FileType3', this.selectedFileType[4]);
      }
      if (this.selectedFileObjects[5] !== undefined) {
        formdata.append('ImageFileUrl4', this.selectedFileObjects[5]);
        formdata.append('FileType4', this.selectedFileType[5]);
      }
      if (this.selectedFileObjects[6] !== undefined) {
        formdata.append('ImageFileUrl5', this.selectedFileObjects[6]);
        formdata.append('FileType5', this.selectedFileType[6]);
      }
      if (this.selectedFileObjects[7] !== undefined) {
        formdata.append('ImageFileUrl6', this.selectedFileObjects[7]);
        formdata.append('FileType6', this.selectedFileType[7]);
      }
      if (this.selectedFileObjects[8] !== undefined) {
        formdata.append('ImageFileUrl7', this.selectedFileObjects[8]);
        formdata.append('FileType7', this.selectedFileType[8]);
      }
      if (this.selectedFileObjects[9] !== undefined) {
        formdata.append('ImageFileUrl8', this.selectedFileObjects[9]);
        formdata.append('FileType8', this.selectedFileType[9]);
      }
      if (this.selectedFileObjects[10] !== undefined) {
        formdata.append('ImageFileUrl9', this.selectedFileObjects[10]);
        formdata.append('FileType9', this.selectedFileType[10]);
      }
      if (_this.defineSendDays !== null && this.defineSendDays !== '') {
        formdata.append("DayDeliver",this.$convertFarsiNumber(this.defineSendDays));
      }
      if (_this.heightCalc !== null && this.heightCalc !== '') {
        formdata.append("HeightCalc", this.$convertFarsiNumber(_this.heightCalc));
      }
      if (_this.editorSendWay.getHTML() !== null && this.editorSendWay.getHTML() !== '') {
        formdata.append("HowSendProduct", _this.editorSendWay.getHTML());
      }
      formdata.append("IsActive", "true");
      if (_this.lengthCalc !== null && this.lengthCalc !== '') {
        formdata.append("LengthCalc",this.$convertFarsiNumber(this.lengthCalc));
      }
      if (this.defineProductName !== null && this.defineProductName !== '') {
        formdata.append("Name", _this.defineProductName);
      }
      if (_this.categoriesVModels !== null && this.categoriesVModels !== '') {
        formdata.append("ProductCategoryID", _this.categoriesVModels[_this.categoriesVModels.length - 1]);
      }
      if (_this.editorEdit.getHTML() !== null && this.editorEdit.getHTML() !== '') {
        formdata.append("ProductReview", _this.editorEdit.getHTML());
      }
      if (_this.productDescriptionEditor.getHTML() !== null && this.productDescriptionEditor.getHTML() !== '') {
        formdata.append("Description", _this.productDescriptionEditor.getHTML());
      }
      if (_this.defineUnitId !== null && _this.defineUnitId !== '') {
        formdata.append("ProductUnitID", _this.defineUnitId);
      }
      formdata.append("TypeVendorProduct", "1");
      formdata.append("TypeVendorProductStatus", "1");
      formdata.append("VendorID", _this.defineProductVendorId);
      if (_this.filterId !== null && this.filterId !== '') {
        let selectedFilter = _this.filterId
        for (let filter in selectedFilter) {
          formdata.append('productcategorydetailid-' + filter, selectedFilter[filter])
        }
      }
      let tips = _this.productTypes
      if (tips !== null && tips !== '') {
        for (let i = 0; i < tips.length; i++) {
          formdata.append("VendorProductTipModels[" + i.toString() + "].ImageFileUrl", tips[i].file);
          formdata.append("VendorProductTipModels[" + i.toString() + "].FileUrl", "");
          formdata.append("VendorProductTipModels[" + i.toString() + "].Color", tips[i].productColor.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].ColorHex", tips[i].color.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].CountAvilable", tips[i].numHave);
          formdata.append("VendorProductTipModels[" + i.toString() + "].Discount", tips[i].productDiscount.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].IsRemove", "False");
          formdata.append("VendorProductTipModels[" + i.toString() + "].Price", tips[i].productPrice.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].Quality", tips[i].quality.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].Size", tips[i].productSize.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].Type", tips[i].type.toString());
          formdata.append("VendorProductTipModels[" + i.toString() + "].VendorProductID", "00000000-0000-0000-0000-000000000000");
        }
      }
      if (_this.weightCalc !== null && this.weightCalc !== '') {
        formdata.append("WeightCalc",this.$convertFarsiNumber( _this.weightCalc.toString()));
      }
      if (_this.widthCalc !== null && this.widthCalc !== '') {
        formdata.append("WidthCalc",this.$convertFarsiNumber( _this.widthCalc.toString()));
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_DefineVendorProduct", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.resultText = JSON.parse(result).Message
              location.reload()
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error))
    },
    editProduct(id) {
      this.showLoaderDialog = true
      this.editSelectedCategories = [];
      this.editChildCategories = [];
      this.editCategoriesVModels = [];
      this.editChildDetailCategories = [];
      this.editFilterId = {}
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_EditVendorProduct?VendorProductID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            let editModel = json.model;
            this.editProductName = editModel.Name;
            this.editProductUnitID = editModel.ProductUnitID;
            this.vendorProductId = editModel.VendorProductID;
            this.editDSendDays = editModel.DayDeliver;
            this.editWeightCalc = editModel.WeightCalc;
            this.editHeightCalc = editModel.HeightCalc;
            this.editWidthCalc = editModel.WidthCalc;
            this.editLengthCalc = editModel.LengthCalc;
            this.editTypeVendorProductStatus = editModel.TypeVendorProductStatus;
            if (editModel.FileUrl !== null) {
              this.hasEditMainPic = true
            }
            this.editMainPic = editModel.FileUrl;
            this.editVendorProductTip(editModel.VendorProductID)
            this.editProductSend = new Editor({
              content: editModel.HowSendProduct
            })
            this.editProductReview = new Editor({
              content: editModel.ProductReview
            })
            this.editProductDescription = new Editor({
              content: editModel.Description
            })
            let category = json.ParentProductCategories
            for (let i = 0; i < category.length; i++) {
              this.editChildCategories.push(category[i].Item2)
              this.editSelectedCategories.push(category[i].Item1)
              this.editCategoriesVModels.push(category[i].Item1)
              this.editLoadChildDetail(editModel.VendorProductID, category[i].Item1)
            }
            this.editIsActive = editModel.IsActive;
            this.editVendorID = editModel.VendorID;
            let gallery = json.productGallery
            gallery.unshift({FileUrl: editModel.FileUrl, TypeStrucGallery: 1})

            for (let i = 0; i < gallery.length; i++) {
              if (gallery[i].FileUrl !== null) {
                this.editHasPhoto[i + 1] = true

              }
            }

            this.editGallery = gallery


            this.editDialog = true
            this.isEditDataLoaded = true
            this.showLoaderDialog = false
            this.isGalleryLoaded = true


            // document.getElementById('imageEdit'+1).style.backgroundImage = "url(" + editModel.FileUrl + ")"

          })
          .catch(error => console.log('error', error));
    },
    editVendorProductTip(id) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_EditVendorProductTip", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let editTips = []
            for (let i = 0; i < json.length; i++) {
              editTips.push({
                productDiscount: json[i].Discount,
                numHave: json[i].CountAvilable,
                productPrice: json[i].Price,
                quality: json[i].Quality,
                productSize: json[i].Size,
                color: json[i].ColorHex,
                productColor: json[i].Color,
                type: json[i].Type,
                menu: false,
                hasEditTipPic: true,
                src: json[i].FileUrl,
                selectedImageFilePath: json[i].FileUrl,
                fileName: null,
                tipId: json[i].VendorProductTipID,
                id: i,
                file: null,
                IsRemove: 'false'
              })
            }
            this.editProductTip = editTips
          })
          .catch(error => console.log('error', error));
    },
    editLoadChildDetail(id, catId) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", id);
      urlencoded.append("ProductCategoryID", catId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadProductCategoryDetialsEditableV2Api", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result).list
            this.editChildDetailCategories.push(json)
            for (let i = 0; i < json.length; i++) {
              this.editFilterId[json[i].ProductCategoryDetailID] = json[i].Value
            }
          })
          .catch(error => console.log('error', error));

    },
    editAppendProductTip() {
      this.editProductTip.push({
        numHave: 0,
        productDiscount: 0,
        productPrice: 0,
        quality: '',
        productSize: '',
        hexCode: '',
        productColor: '',
        type: '',
        color: '#000000',
        menu: false,
        src: null,
        selectedImageFilePath: null,
        fileName: null,
        hasEditTipPic: false,
        VendorProductTipID: null,
        file: null,
        id: this.editProductTip.length,
        IsRemove: 'false'
      })
    },
    editLoadChildCategories(id, index) {

      if (index === 0 || index === 1) {
        _this.editChildDetailCategories = []
      } else {
        _this.editChildDetailCategories.splice(index + 1, _this.editChildDetailCategories.length - index + 1)
      }
      _this.editSelectedCategories.splice(index + 1, _this.editSelectedCategories.length - index + 1)
      _this.editChildCategories.splice(index + 1, _this.editChildCategories.length - index + 1)


      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductCategoryID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadChildDetialCategoriesApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              _this.editChildDetailCategories.push(json)
            }

          })
          .catch(error => console.log('error', error));


      let myHeaders1 = new Headers();
      myHeaders1.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded1 = new URLSearchParams();
      urlencoded1.append("ProductCategoryParentID", id);

      let requestOptions1 = {
        method: 'POST',
        headers: myHeaders1,
        body: urlencoded1,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadChildCategoriesApi", requestOptions1)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              _this.editChildCategories.push(json)
              _this.editSelectedCategories.push(id)
            }

          })
          .catch(error => console.log('error', error));

    },
    editRemoveTip(index) {
      if (this.editProductTip.length === 1) {
        this.resultText = 'حداقل یک تیپ باید تعریف کنید'
        this.showResult = true
      } else {
        // this.editProductTip.splice(index, 1)
        this.editProductTip[index].IsRemove = 'true'
      }
    },
    removeProductTypePhotoEdit(i) {
      document.getElementById('typeImageInputEdit' + i).style.backgroundImage = ""
      this.editProductTip[i].selectedImageFilePath = ""
      this.editProductTip[i].hasEditTipPic = false
    },
    openUploadFileForTypesEdit(i) {
      document.getElementById('typeImageInputEdit' + i).click()
    },
    productTypePhotoEdit(e, i) {
      let files = e.target.files;
      if (files.length > 0) {
        this.editProductTip[i].hasEditTipPic = true
        let imageName = files[0].name
        if (imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          // document.getElementById('typeImage' + i).style.backgroundImage = "url(" + fr.result + ")"
          this.editProductTip[i].selectedImageFilePath = fr.result
          this.editProductTip[i].file = files[0]
          this.selectedImageCoverFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.productTypes[i].hasEditTipPic = false

      }
    },
    editDefineProduct() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      let formdata = new FormData();
      if (this.selectedFileObjectsEdit[1] !== null && this.selectedFileObjectsEdit[1] !== undefined) {
        formdata.append('ImageFileUrl', this.selectedFileObjectsEdit[1]);

      } else {
        formdata.append("FileUrl", this.editMainPic);
      }
      if (this.editDSendDays !== null && this.editDSendDays !== '' && this.editDSendDays !== undefined) {
        formdata.append("DayDeliver",this.$convertFarsiNumber(this.editDSendDays));
      }
      if (this.editHeightCalc !== null && this.editHeightCalc !== '' && this.editHeightCalc !== undefined) {
        formdata.append("HeightCalc", this.editHeightCalc.toString());
      }
      if (this.editProductSend.getHTML() !== null && this.editProductSend.getHTML() !== '' && this.editProductSend.getHTML() !== undefined) {
        formdata.append("HowSendProduct", this.editProductSend.getHTML());
      }
      if (_this.editProductDescription.getHTML() !== null && this.editProductDescription.getHTML() !== '') {
        formdata.append("Description", _this.editProductDescription.getHTML());
      }
      formdata.append("IsActive", this.editIsActive);
      if (this.editLengthCalc !== null && this.editLengthCalc !== '' && this.editLengthCalc !== undefined) {
        formdata.append("LengthCalc", this.editLengthCalc.toString());
      }
      if (this.editProductName !== null && this.editProductName !== '' && this.editProductName !== undefined) {
        formdata.append("Name", this.editProductName.toString());
      }
      if (this.vendorProductId !== null && this.vendorProductId !== '' && this.vendorProductId !== undefined) {
        formdata.append("VendorProductID", this.vendorProductId.toString());
      }
      if (this.editCategoriesVModels !== null && this.editCategoriesVModels !== '' && this.editCategoriesVModels !== undefined) {
        formdata.append("ProductCategoryID", this.editCategoriesVModels[this.editCategoriesVModels.length - 1].toString());
      }
      if (this.editProductReview.getHTML() !== null && this.editProductReview.getHTML() !== '' && this.editProductReview.getHTML() !== undefined) {
        formdata.append("ProductReview", this.editProductReview.getHTML());
      }
      if (this.editProductUnitID !== null && this.editProductUnitID !== '' && this.editProductUnitID !== undefined) {
        formdata.append("ProductUnitID", this.editProductUnitID.toString());
      }
      formdata.append("TypeVendorProduct", "1");
      formdata.append("TypeVendorProductStatus", this.editTypeVendorProductStatus);
      formdata.append("VendorID", this.editVendorID.toString());

      if (this.editFilterId !== null && this.editFilterId !== '') {
        let selectedFilter = this.editFilterId
        for (let filter in selectedFilter) {
          formdata.append('productcategorydetailid-' + filter, selectedFilter[filter])
        }
      }
      let tips = this.editProductTip
      if (tips !== null) {
        for (let i = 0; i < tips.length; i++) {
          if (tips[i].productColor !== null && tips[i].productColor !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Color", tips[i].productColor.toString());
          }
          if (tips[i].tipId !== null && tips[i].tipId !== '' && tips[i].tipId !== undefined) {
            formdata.append("VendorProductTipModels[" + i.toString() + "].VendorProductTipID", tips[i].tipId);
          }
          if (tips[i].color !== null && tips[i].color !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].ColorHex", tips[i].color.toString());
          }
          if (tips[i].file !== null) {
            formdata.append("VendorProductTipModels[" + i.toString() + "].FileUrl", "");
            formdata.append("VendorProductTipModels[" + i.toString() + "].ImageFileUrl", tips[i].file);
          } else {
            formdata.append("VendorProductTipModels[" + i.toString() + "].FileUrl", tips[i].src);
          }
          if (tips[i].numHave !== null && tips[i].numHave !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].CountAvilable", tips[i].numHave.toString());
          }
          if (tips[i].productDiscount !== null && tips[i].productDiscount !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Discount", tips[i].productDiscount.toString());
          }
          formdata.append("VendorProductTipModels[" + i.toString() + "].IsRemove", tips[i].IsRemove.toString());
          if (tips[i].productPrice !== null && tips[i].productPrice !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Price", tips[i].productPrice.toString());
          }
          if (tips[i].quality !== null && tips[i].quality !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Quality", tips[i].quality.toString());
          }
          if (tips[i].productSize !== null && tips[i].productSize !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Size", tips[i].productSize.toString());
          }
          if (tips[i].type !== null && tips[i].type !== '') {
            formdata.append("VendorProductTipModels[" + i.toString() + "].Type", tips[i].type.toString());
          }
          formdata.append("VendorProductTipModels[" + i.toString() + "].VendorProductID", this.vendorProductId);

        }
      }
      if (this.editWeightCalc !== null && this.editWeightCalc !== '') {
        formdata.append("WeightCalc", this.editWeightCalc.toString());
      }
      if (this.editWidthCalc !== null && this.editWidthCalc !== '') {
        formdata.append("WidthCalc", this.editWidthCalc.toString());
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_EditVendorProduct", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              if (this.isMediaChanged) {
                for (let i = 2; i <= 10; i++) {
                  if (this.selectedGalleryIDEdit[i] !== undefined) {
                    this.editGalleryItems(this.selectedGalleryIDEdit[i], this.selectedFileTypeEdit[i], this.selectedFileObjectsEdit[i],)
                  } else if (this.selectedFileObjectsEdit[i] !== undefined) {
                    this.defineGalleryItems(this.selectedFileTypeEdit[i], this.selectedFileObjectsEdit[i],)
                  }
                }
              } else {
                this.resultText = JSON.parse(result).Message
                this.closeEditDialog()
              }
              // this.getProductsList()
            } else {
              this.resultText = result

            }
            this.showResult = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));

    },
    editGalleryItems(id, type, file) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("ImageFileUrl", file);
      formdata.append("TypeStrucGallery", type);
      formdata.append("VendorProductID", this.vendorProductId);
      formdata.append("VendorProductGalleryID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_EditProductGallery", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            this.showLoaderDialog = false
            this.closeEditDialog()
          })
          .catch(error => console.log('error', error));
    },
    defineGalleryItems(type, file) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("ImageFileUrl", file);
      formdata.append("TypeStrucGallery", type);
      formdata.append("VendorProductID", this.vendorProductId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_DefineProductGallery", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log('result', result)
            this.showLoaderDialog = false
            this.closeEditDialog()
          })
          .catch(error => console.log('error', error));
    },
    videoLoaded(e) {
      let videoElem = e.target;
      videoElem.currentTime = 5
      videoElem.pause()

    },
    closeEditDialog() {
      this.editDialog = false
      this.getProductsList()
    },
    getGalleryItems(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorProductManagement/_ListProductGallery?VendorProductID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)
            this.galleryItems = json.filter(x => x.IsActive === true)
            this.openGalleryBottomSheet = true
          })
          .catch(error => console.log('error', error));
    },
    showSelectedGalleryItem(type, file) {
      this.isSelectedGalleryItem = true
      if (type === 1) {
        this.srcSelectedGallery = file
        this.typeGalleryIsPicture = true
      } else {
        this.typeGalleryIsPicture = false
        this.srcSelectedGallery = file
      }
    },
    closeGalleryBottomSheet(){
      this.openGalleryBottomSheet=false
      this.isSelectedGalleryItem = false
    }
  }
}
</script>

<style scoped>

</style>
